import * as React from "react";
import { connect } from "react-redux";
import { Menu, MenuItemProps } from "piral";
import { Navbar, Nav } from "react-bootstrap";
import { handleOpenMenu, initKeyboardFocus, destroyKeyboardFocus } from "../utils/CAK.Utils";
import { ApplicationState } from "../store";
import env from "../env";

export const MenuItem: React.FC<MenuItemProps> = ({ children }) => <>{children}</>;

const ConnectedMenu = (_props: IStateFromProps) => {
  React.useEffect(() => {
    initKeyboardFocus();
    return () => {
      destroyKeyboardFocus();
    };
  }, []);
  const [isNavCollapsed, setIsNavCollapsed] = React.useState(false);

  const handleNavCollapse = () => {
    setIsNavCollapsed(!isNavCollapsed);
    handleOpenMenu(!isNavCollapsed);
  };

  const handleNavCollapseOnBreakpoint = () => {
    setIsNavCollapsed(false);
    handleOpenMenu(false);
  };

  const handleMobileMenuAriaHidden = () => {
    const mobileMenuContainer = document.querySelector(".mobile-toggle-menu-container");
    const mobileMenuToggler = document.querySelector(".mobile-toggle-menu-container .navbar-toggler");

    if (mobileMenuContainer) {
      if (mobileMenuToggler && window.getComputedStyle(mobileMenuToggler).display === "none") {
        mobileMenuContainer.setAttribute("aria-hidden", "true");
      } else {
        mobileMenuContainer.setAttribute("aria-hidden", "false");
      }
    }
  };

  const handleMenuControlsOnBreakpointSize = () => {
    const normalMenuViewPoints: string[] = ["lg", "xl"];
    const breakpointDivs = document.getElementById("breakpoint-sizer")?.querySelectorAll("div");
    const currentBreakPoint = breakpointDivs
      ? Array.from(breakpointDivs)
          .find((el) => window.getComputedStyle(el).display !== "none")
          ?.getAttribute("data-size")
      : null;
    // close menu, reset indexes, remove body class on resize Vw "lg" + "xl".
    if (
      currentBreakPoint &&
      normalMenuViewPoints.includes(currentBreakPoint) &&
      document.querySelector(".openMenu")
    ) {
      handleNavCollapseOnBreakpoint();
    }
    if (currentBreakPoint) {
      handleMobileMenuAriaHidden();
    }
  };

  React.useEffect(() => {
    handleMobileMenuAriaHidden();
  }, []);

  window.addEventListener("resize", handleMenuControlsOnBreakpointSize);

  return (
    <header>
      <div className="container-fluid container-no-padding header-nav-container fixed-top">
        <Navbar
          collapseOnSelect
          expand="lg"
          expanded={isNavCollapsed}
          bg="header-cak"
          variant="light"
          className="container"
          onToggle={handleNavCollapse}
          role="navigation"
          aria-label="Main navigation"
          id="main-menu"
        >
          <Navbar.Brand
            href="https://www.hetcak.nl"
            aria-hidden="false"
            tabIndex={0}
            id="header-navbar-brand"
          >
            <img src={`${env.APPLICATION_PATH}/images/cak-logo.png`} alt="Logo C.A.K" />
          </Navbar.Brand>
          <div className="mobile-toggle-menu-container" aria-hidden>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" aria-haspopup="true" id="mobile-toggle-menu">
              <span className="sr-only">Open navigatie</span>
              <span className="icon-bar" aria-hidden />
              <span className="icon-bar" aria-hidden />
              <span className="icon-bar" aria-hidden />
              <span className="icon-text">Menu</span>
            </Navbar.Toggle>
          </div>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Navbar.Toggle
              aria-controls="responsive-navbar-nav"
              className="mobileclosebutton"
              id="mobile-close-button"
            >
              <span className="sr-only">Sluit navigatie</span>
              <img
                src={`${env.APPLICATION_PATH}/images/close-white.svg`}
                alt="Sluit navigatie menu"
                aria-hidden="true"
              />
            </Navbar.Toggle>

            <Nav className="mr-auto" id="open-cak-nav-list" role="menu">
              <Menu type="header" />
            </Nav>
            <Nav className="ml-auto " id="naar-homepage-link" role="menu">
              <Nav.Link
                id="menu-item-to-homepage"
                eventKey={2}
                href="#"
                role="menuitem"
                onClick={() => {
                  window.location.href = "https://www.hetcak.nl/";
                }}
              >
                <img
                  src={`${env.APPLICATION_PATH}/images/home-icon-pink.svg`}
                  className="naar-homepage-menu-icon"
                  aria-hidden="true"
                  alt=""
                />
                <img
                  src={`${env.APPLICATION_PATH}/images/home-icon-white.svg`}
                  className="naar-homepage-menu-icon-mobile"
                  aria-hidden="true"
                  alt=""
                />
                terug naar homepage
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>

      <div className="container-fluid home-seperator">
        <div className="row line" />
      </div>
    </header>
  );
};

interface IStateFromProps {}

const mapStateToProps = (_state: ApplicationState): IStateFromProps => ({});

export const HeaderContainer = connect<IStateFromProps>(mapStateToProps)(ConnectedMenu);
